var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrainIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1821 23.8703C34.1821 33.2659 30.5583 42.0953 24.1854 49.7789",
    stroke: "url(#paint0_linear_333_4365)",
    strokeWidth: 1.933,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6524 16.0941C35.074 16.146 35.2551 17.4925 35.0569 19.1016C34.8586 20.7106 34.356 21.9728 33.9344 21.9209C33.5127 21.8689 33.3316 20.5224 33.5299 18.9134C33.7282 17.3044 34.2307 16.0421 34.6524 16.0941Z",
    fill: "url(#paint1_linear_333_4365)",
    stroke: "url(#paint2_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3543 23.5561C36.0303 23.2823 36.6155 22.0569 37.6614 20.8191C38.7073 19.5814 39.8178 18.7999 40.1418 19.0737C40.4659 19.3475 39.8806 20.5728 38.8347 21.8106C37.7888 23.0484 36.6783 23.8299 36.3543 23.5561Z",
    fill: "url(#paint3_linear_333_4365)",
    stroke: "url(#paint4_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0937 24.8491C30.5331 25.0419 29.6515 23.9558 29.1245 22.4232C28.5975 20.8906 28.6247 19.492 29.1852 19.2992C29.7458 19.1065 30.6274 20.1926 31.1544 21.7252C31.6814 23.2577 31.6542 24.6564 31.0937 24.8491Z",
    fill: "url(#paint5_linear_333_4365)",
    stroke: "url(#paint6_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4524 27.6542C37.1284 27.3804 37.7136 26.1551 38.7595 24.9173C39.8055 23.6795 40.916 22.898 41.24 23.1718C41.564 23.4456 40.9788 24.671 39.9329 25.9087C38.887 27.1465 37.7764 27.928 37.4524 27.6542Z",
    fill: "url(#paint7_linear_333_4365)",
    stroke: "url(#paint8_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8256 31.0453C29.2651 31.238 28.3834 30.1519 27.8564 28.6193C27.3294 27.0868 27.3566 25.6881 27.9172 25.4954C28.4777 25.3026 29.3594 26.3887 29.8864 27.9213C30.4134 29.4539 30.3862 30.8525 29.8256 31.0453Z",
    fill: "url(#paint9_linear_333_4365)",
    stroke: "url(#paint10_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0557 31.7761C36.8056 31.4335 37.6642 30.3808 38.9735 29.4247C40.2827 28.4687 41.5469 27.9714 41.7971 28.314C42.0472 28.6566 41.1886 29.7093 39.8793 30.6654C38.5701 31.6214 37.3059 32.1187 37.0557 31.7761Z",
    fill: "url(#paint11_linear_333_4365)",
    stroke: "url(#paint12_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4567 35.6954C35.326 35.2919 36.4703 34.5598 38.0125 34.0603C39.5548 33.5608 40.911 33.4831 41.0417 33.8866C41.1724 34.2901 40.0281 35.0222 38.4858 35.5217C36.9436 36.0212 35.5874 36.099 35.4567 35.6954Z",
    fill: "url(#paint13_linear_333_4365)",
    stroke: "url(#paint14_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5576 37.2414C27.997 37.4342 27.1154 36.3481 26.5884 34.8155C26.0614 33.2829 26.0886 31.8843 26.6491 31.6915C27.2096 31.4988 28.0913 32.5849 28.6183 34.1175C29.1453 35.65 29.1181 37.0487 28.5576 37.2414Z",
    fill: "url(#paint15_linear_333_4365)",
    stroke: "url(#paint16_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9238 43.8036C25.3632 43.9964 24.4816 42.9102 23.9546 41.3777C23.4276 39.8451 23.4548 38.4465 24.0153 38.2537C24.5759 38.061 25.4575 39.1471 25.9845 40.6796C26.5115 42.2122 26.4843 43.6108 25.9238 43.8036Z",
    fill: "url(#paint17_linear_333_4365)",
    stroke: "url(#paint18_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.693 41.1041C32.5623 40.7005 33.7066 39.9685 35.2489 39.469C36.7911 38.9695 38.1473 38.8917 38.278 39.2953C38.4087 39.6988 37.2644 40.4309 35.7222 40.9303C34.1799 41.4298 32.8237 41.5076 32.693 41.1041Z",
    fill: "url(#paint19_linear_333_4365)",
    stroke: "url(#paint20_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3727 45.7448C30.242 45.3413 31.3863 44.6092 32.9286 44.1097C34.4708 43.6102 35.827 43.5325 35.9577 43.936C36.0884 44.3395 34.9441 45.0716 33.4019 45.5711C31.8596 46.0706 30.5034 46.1484 30.3727 45.7448Z",
    fill: "url(#paint21_linear_333_4365)",
    stroke: "url(#paint22_linear_333_4365)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 31.5,
    stroke: "#FFA500",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_333_4365",
    x1: 34.1821,
    y1: 77.6897,
    x2: 34.1821,
    y2: 23.8703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_333_4365",
    x1: 33.1709,
    y1: 21.8268,
    x2: 34.6978,
    y2: 22.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_333_4365",
    x1: 33.1709,
    y1: 21.8268,
    x2: 34.6978,
    y2: 22.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_333_4365",
    x1: 40.7285,
    y1: 19.5694,
    x2: 39.5552,
    y2: 18.5779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_333_4365",
    x1: 40.7285,
    y1: 19.5694,
    x2: 39.5552,
    y2: 18.5779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_333_4365",
    x1: 30.2002,
    y1: 18.9502,
    x2: 28.1703,
    y2: 19.6483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_333_4365",
    x1: 30.2002,
    y1: 18.9502,
    x2: 28.1703,
    y2: 19.6483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_333_4365",
    x1: 41.8267,
    y1: 23.6675,
    x2: 40.6533,
    y2: 22.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_333_4365",
    x1: 41.8267,
    y1: 23.6675,
    x2: 40.6533,
    y2: 22.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_333_4365",
    x1: 28.9321,
    y1: 25.1464,
    x2: 26.9022,
    y2: 25.8444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_333_4365",
    x1: 28.9321,
    y1: 25.1464,
    x2: 26.9022,
    y2: 25.8444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_333_4365",
    x1: 42.25,
    y1: 28.9343,
    x2: 41.3441,
    y2: 27.6937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_333_4365",
    x1: 42.25,
    y1: 28.9343,
    x2: 41.3441,
    y2: 27.6937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_333_4365",
    x1: 41.2783,
    y1: 34.6173,
    x2: 40.805,
    y2: 33.1559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_333_4365",
    x1: 41.2783,
    y1: 34.6173,
    x2: 40.805,
    y2: 33.1559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_333_4365",
    x1: 27.6641,
    y1: 31.3425,
    x2: 25.6342,
    y2: 32.0406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_333_4365",
    x1: 27.6641,
    y1: 31.3425,
    x2: 25.6342,
    y2: 32.0406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_333_4365",
    x1: 25.0303,
    y1: 37.9047,
    x2: 23.0004,
    y2: 38.6027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_333_4365",
    x1: 25.0303,
    y1: 37.9047,
    x2: 23.0004,
    y2: 38.6027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_333_4365",
    x1: 38.5146,
    y1: 40.0259,
    x2: 38.0414,
    y2: 38.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_333_4365",
    x1: 38.5146,
    y1: 40.0259,
    x2: 38.0414,
    y2: 38.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_333_4365",
    x1: 36.1943,
    y1: 44.6667,
    x2: 35.721,
    y2: 43.2053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_333_4365",
    x1: 36.1943,
    y1: 44.6667,
    x2: 35.721,
    y2: 43.2053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ED32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrainIcon);
export default __webpack_public_path__ + "static/media/grainIcon.6a3b643cf624716d00927c71a1c11e27.svg";
export { ForwardRef as ReactComponent };